import { useRequestHeader } from '#app/composables/ssr';
import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useUserAgentState } from '~/composables/useUserAgentState';

export default defineNuxtRouteMiddleware(async () => {
  const { userAgentState } = useUserAgentState();

  if (userAgentState.value === '') {
    const ua = useRequestHeader('user-agent');
    userAgentState.value = ua ?? '';
  }
});
